import BaseResource from './index'
import { moneyFormatFromPositiveInteger, timeDateFormattedPretty } from '../util'


export default class ChargeResource extends BaseResource {
    static endpoint = '/users/me/charges'

    static async captureOutstanding() {
        let wrapped = this.wrap('/capture_outstanding')
        return await wrapped.post()
    }

    static async addVoucherToAccount(voucherId) {
        let wrapped = this.wrap('/apply_voucher_to_account')
        return await wrapped.post({ voucher_id: voucherId })
    }

    static async finalQuote(amountCents) {
        const wrapped = this.wrap('/final_quote')
        const result = await wrapped.get({ params: { amount_cents: amountCents } })
        return result.data
    }

    static async creditPurchaseQuote(creditsAmount) {
        const wrapped = this.wrap('/credits_purchase_quote')
        const result = await wrapped.get({ params: { credits: creditsAmount }})
        return result.data
    }

    static async creditEnrollUser(creditsAmount) {
        const wrapped = this.wrap('/credits_enroll')
        return await wrapped.post({ credits_amount: creditsAmount })
    }

    static async creditUnenrollUser() {
        const result = await this.wrap('/credits_unenroll').post()
        return result.status > 199 && result.status < 400
    }

    static async getOutstandingBalance() {
        let wrapped = this.wrap('/balance')
        let result = await wrapped.get()
        return result.data.amount_cents
    }

    amount() {
        return moneyFormatFromPositiveInteger(this.attributes.amount_cents)
    }

    createdTimePretty() {
        return timeDateFormattedPretty(this.attributes.created)
    }
    

    toString() {
        return this.attributes.charge_id
    }
}
